module.exports = __webpack_public_path__ + "static/media/seglogic-landing.e17eb963.png";